
export default {
  data() {
    return {
      options: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$isInViewport("infinite-slider", true);
    });
  },
};
